import { MatchResults } from '@/common/constants';
import type { MatchResult } from '@/common/types';

interface TeamsTableFormCellProps {
  form: MatchResult[];
}

const MAX_FORM_DOTS = 5;

const formDotColorClassMap = {
  [MatchResults.WIN]: 'bg-success dark:bg-sucess090',
  [MatchResults.DRAW]: 'bg-base090 dark:bg-base0',
  [MatchResults.LOSS]: 'bg-error dark: bg-error090',
};

export default function TeamsTableFormCell({ form }: TeamsTableFormCellProps) {
  return (
    // latest match on the right; assuming that the latest match in data is the first element
    <div className="flex flex-row-reverse justify-start items-center gap-[2px] px-[4px]">
      {form.slice(0, MAX_FORM_DOTS).map((matchResult, index) => {
        const isLatestMatchResult = index === 0;
        return (
          <div
            // using index because there is no other way to get unique keys in this case
            // it also doesn't matter for form dots
            key={index}
            className={`relative w-[8px] h-[8px] rounded-full ${formDotColorClassMap[matchResult]}`}
          >
            {isLatestMatchResult && (
              <div
                className={`absolute inset-x-0 bottom-[-2.5px] w-[7px] h-px mx-auto rounded-[1px] ${formDotColorClassMap[matchResult]}`}
              />
            )}
          </div>
        );
      })}
    </div>
  );
}
